import { inject } from '@angular/core';
import { NavigationError } from '@angular/router';
import { isMissingChunkError } from './missing-chunk-errors';
import { MissingChunkReloadService } from './missing-chunk-reload.service';

/**
 * Handler for `withNavigationErrorHandler`: when a lazy route's chunk is gone,
 * loads the destination as a full page.
 */
export function reloadOnMissingRouteChunk(error: NavigationError): void {
  if (isMissingChunkError(error.error)) {
    inject(MissingChunkReloadService).loadFreshPage(error, error.url);
  }
}
